import React from "react";
import PropTypes from "prop-types";
import { PlainText } from "@learningblocks/simulations/shared-components";
import style from "./style.module.scss";
import { FormattedMessage } from "react-intl";

/**
 * OptionFeedback:
 *  - Feedback message for a particular Option
 */
export function OptionFeedback(props) {
  if (props.visible) {
    return (
      <div className={`${style.feedback} ${props.className}`} dir="auto">
        {props.text && typeof props.text === "string" && (
          <p>
            <FormattedMessage id={props.text} defaultMessage={props.text} />
          </p>
        )}
        {props.text && typeof props.text === "object" && (
          <PlainText {...props.text} />
        )}
      </div>
    );
  } else return null;
}

OptionFeedback.propTypes = {
  /**
   * Boolean specifying if feedback is visible
   */
  visible: PropTypes.bool.isRequired,
  /**
   * text to be displayed as feedback
   */
  text: PropTypes.string.isRequired,
  /**
   * className to be set for feedback element
   */
  className: PropTypes.string,
};

OptionFeedback.defaultProps = {
  visible: false,
  text: "",
};
